import { render, staticRenderFns } from "./PackagePlaceOrder.vue?vue&type=template&id=3b61f3ec&scoped=true&"
import script from "./PackagePlaceOrder.vue?vue&type=script&lang=js&"
export * from "./PackagePlaceOrder.vue?vue&type=script&lang=js&"
import style0 from "./PackagePlaceOrder.vue?vue&type=style&index=0&id=3b61f3ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b61f3ec",
  null
  
)

export default component.exports